var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user.id)?_c('a',{class:{ selected: _vm.inFavorites },on:{"click":_vm.submit}},[_c('div',{staticClass:"icon icon-favourites icon-right"})]):_c('a',{staticClass:"empty"})
}
var staticRenderFns = []

export { render, staticRenderFns }